import { createReducer } from '@reduxjs/toolkit';
import { setIsLoading } from '@innovyze/stylovyze/lib/actions/app.actions';
export const initialState = true;
const reducer = {
    [setIsLoading.toString()]: (state, action) => action.payload,
};
export default createReducer(initialState, reducer);
